import {
    type Element,
    type SlateEditor,
} from '@udecode/plate';

import { BaseFigureCaptionPlugin } from '../FigureCaptionBasePlugin';

export const isAbove = (
    editor: SlateEditor,
    currentElement: Element
): boolean => {
    const pathBefore = editor.api.before(currentElement);

    const entry = editor.api.block({
        at: pathBefore,
    });

    return !!(entry && entry[0].type === editor.getType(BaseFigureCaptionPlugin));
};
